import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent } from '@mui/material';
import CheckboxList from 'components/common/CheckboxList';
import { ModalActionProps } from 'models/AutoModals';
import { CarModel } from 'models/StockModel';


type TransferCarsDialogProps = {
    cars: CarModel[],
} & ModalActionProps<number[]>

const TransferCarsDialog = ({cars, onFinish}: TransferCarsDialogProps) => {
    const {t} = useTranslation('cars');
    const [checked, setChecked] = useState(cars.map(() =>  true));

    const submit = () => {
        const selected = cars.filter((_, i) => checked[i]).map(c => c.id);

        if (selected.length)
            onFinish(selected)
    }

    useEffect(() => {
        const handlePaste = (event: ClipboardEvent) => {
            const pasted = event.clipboardData?.getData('Text');

            if (!pasted)
                return;

            const chassis = new Set(pasted.trim().split('\n').map(s => s.trim()));
            setChecked(cars.map(car =>  chassis.has(car.chassisNumber)));
        };

        document.addEventListener('paste', handlePaste);

        return () => {
            document.removeEventListener('paste', handlePaste);
        };
    }, [cars]);

    return (
        <>
            <DialogContent>
                <CheckboxList
                    items={cars}
                    formatter={c => <Box display="flex" justifyContent="space-between" gap={2}>
                        <Box component="small">{c.model}</Box>
                        <Box>{c.chassisNumber}</Box>
                    </Box>}
                    checked={checked}
                    setChecked={setChecked}
                />
            </DialogContent>

            <DialogActions sx={{justifyContent: 'space-between'}}>
                <Box fontSize={12} color="text.disabled">Paste chassis to select</Box>
                <Button onClick={submit}>{t('apply')}</Button>
            </DialogActions>
        </>
    );
};

export default TransferCarsDialog;
